import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { TextField } from '@mui/material';
import moment from 'moment';

export default function Viewavakdata() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);

    const [avakdatas, setavakdatas] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [updocid, setupdocid] = useState("");

    const [avakdate, setavakdate] = useState(moment().format('YYYY-MM-DD'));
    const [billdate, setbilldate] = useState(moment().format('YYYY-MM-DD'));
    const [alltotal, setalltotal] = useState(" ");
    const [avakpersonname, setavakpersonname] = useState(" ");
    const [dealername, setdealername] = useState(0);
    const [billno, setbillno] = useState(0);
    const [materaildate, setmateraildate] = useState(moment().format('YYYY-MM-DD'));
    const [storedate, setstoredate] = useState(moment().format('YYYY-MM-DD'));
    const [billnote1, setbillnote1] = useState(" ");
    const [billnote2, setbillnote2] = useState(" ");

    // pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // rows per page

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'avakregisters'), orderBy('avakdate', 'desc'))
            onSnapshot(q, (querySnapshot) => {
                setavakdatas(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = avakdatas.filter((item) =>
                item.data.avakpersonname.toUpperCase().includes(searchText.toUpperCase())
            );
            setavakdatas(filteredData);
            setCurrentPage(1); // reset to first page on search
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleDelete = async (docid) => {
        try {
            const avakItemsQuery = query(collection(db, 'avakitems'), where("avakid", "==", docid));
            const avakItemsSnapshot = await getDocs(avakItemsQuery);
            const deletePromises = avakItemsSnapshot.docs.map((doc) => deleteDoc(doc.ref));
            await Promise.all(deletePromises);
            await deleteDoc(doc(db, 'avakregisters', docid));
            Toast.fire({
                icon: "success",
                title: 'Avak Data and Related Items Deleted Successfully!!'
            });
            fetchData1();
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: 'Error deleting data. Please try again!'
            });
            console.error("Error deleting data:", error);
        }
    };

    const handleEdit = (id, avakdate, alltotal, avakpersonname, dealername, billno, billdate, materaildate, storedate, billnote1, billnote2) => {
        setupdocid(id);
        setavakdate(avakdate)
        setbilldate(billdate)
        setalltotal(alltotal)
        setavakpersonname(avakpersonname)
        setdealername(dealername)
        setbillno(billno)
        setmateraildate(materaildate)
        setstoredate(storedate)
        setbillnote1(billnote1)
        setbillnote2(billnote2)
    }

    const handleUpdate = async () => {
        await updateDoc(doc(db, "avakregisters", updocid), {
            avakdate, alltotal, avakpersonname, dealername,
            billno, billdate, materaildate, storedate, billnote1, billnote2,
        });
        Toast.fire({
            icon: "success",
            title: 'Avak Data Updated Successfully!!'
        });
        fetchData1();
    }

    // pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = avakdatas.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(avakdatas.length / itemsPerPage);


    // inside your Viewavakdata component

    // TRANSFER FUNCTION WITH CONFIRM ALERT
    const handleTransfer = async (avak) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will transfer the Avak data to Javak!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Transfer it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Step 1: create new javakregister
                    const javakRef = await addDoc(collection(db, "javakregisters"), {
                        javakdate: avak.data.avakdate,
                        javakpersonname: avak.data.avakpersonname,
                        javaknote: `Transferred from Avak`,
                        extra1: "",
                        extra2: "",
                        extra3: "",
                        extra4: "",
                        uid: userData?.uid,
                        createdAt: Timestamp.now(),
                    });

                    // Step 2: fetch avakitems for this avakid
                    const avakItemsQuery = query(
                        collection(db, "avakitems"),
                        where("avakid", "==", avak.id)
                    );
                    const avakItemsSnapshot = await getDocs(avakItemsQuery);

                    // Step 3: create javakitems from avakitems
                    const transferPromises = avakItemsSnapshot.docs.map((docSnap) =>
                        addDoc(collection(db, "javakitems"), {
                            avakid: avak.id,
                            javakid: javakRef.id,
                            product: docSnap.data().product,
                            productid: docSnap.data().productid,
                            quantity: docSnap.data().quantity,
                            size: docSnap.data().size,
                            uid: userData?.uid,
                            username: docSnap.data().username || "",
                            javakdate: avak.data.avakdate,
                            createdAt: Timestamp.now(),
                        })
                    );

                    await Promise.all(transferPromises);

                    Swal.fire(
                        "Transferred!",
                        "Avak data has been successfully transferred to Javak.",
                        "success"
                    );
                } catch (error) {
                    console.error("Error transferring data:", error);
                    Swal.fire("Error!", "Error transferring data. Please try again!", "error");
                }
            }
        });
    };


    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View Avak Data ||</button><br /><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                <input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />
                            </div>
                            <div className="card-body table-responsive p-0" >
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Sr No</th>
                                            <th>Avak Date </th>
                                            <th>Person Name </th>
                                            <th>Total </th>
                                            <th>Bill No </th>
                                            <th>Dealer Name </th>
                                            <th>Note </th>
                                            {/* <th>Items </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((item, index) =>
                                            <tr key={item.id}>
                                                <td>
                                                    <a onClick={() => handleEdit(item.id, item.data.avakdate, item.data.alltotal, item.data.avakpersonname, item.data.dealername, item.data.billno, item.data.billdate, item.data.materaildate, item.data.storedate, item.data.billnote1, item.data.billnote2)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                    <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    <a className="btn btn-sm bg-purple" href={'avak-details/' + item.id} > <i className="fa fa-eye"></i></a>&nbsp;
                                                    <a href='#0' onClick={() => handleTransfer(item)} className="btn btn-sm btn-warning">
                                                        <i className="fa fa-random"></i>
                                                    </a>
                                                </td>
                                                <td>{indexOfFirstItem + index + 1}</td>
                                                <td>{moment(item.data.avakdate).format('DD-MM-YYYY')}</td>
                                                <td>{item.data.avakpersonname}</td>
                                                <td>{item.data.alltotal}</td>
                                                <td>{item.data.billno}</td>
                                                <td>{item.data.dealername}</td>
                                                <td>{item.data.billnote1}<br />{item.data.billnote2}</td>
                                                {/* <td>
                                                    {item.data.avakitems?.map((item1, idx) =>
                                                        <div key={idx}>
                                                            <span># {item1.product} ({item1.quantity} Qty)</span>
                                                        </div>
                                                    )}
                                                </td> */}
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination Controls */}
                            <div className="card-footer d-flex justify-content-between">
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    Prev
                                </button>
                                <span> Page {currentPage} of {totalPages} </span>
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal (unchanged) */}
            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Avak Data</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <TextField
                                        fullWidth
                                        label="Avak Date"
                                        type="date"
                                        value={avakdate}
                                        onChange={(e) => setavakdate(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                    <TextField
                                        fullWidth
                                        label="Person Name"
                                        value={avakpersonname}
                                        onChange={(e) => setavakpersonname(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                    <TextField
                                        fullWidth
                                        label="Total"
                                        type="number"
                                        value={alltotal}
                                        onChange={(e) => setalltotal(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                </div>

                                <div className="col-sm-6">
                                    <TextField
                                        fullWidth
                                        label="Dealer Name"
                                        value={dealername}
                                        onChange={(e) => setdealername(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                    <TextField
                                        fullWidth
                                        label="Bill No"
                                        value={billno}
                                        onChange={(e) => setbillno(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                    <TextField
                                        fullWidth
                                        label="Bill Date"
                                        type="date"
                                        value={billdate}
                                        onChange={(e) => setbilldate(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                </div>

                                <div className="col-sm-6">
                                    <TextField
                                        fullWidth
                                        label="Material Date"
                                        type="date"
                                        value={materaildate}
                                        onChange={(e) => setmateraildate(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                </div>

                                <div className="col-sm-6">
                                    <TextField
                                        fullWidth
                                        label="Store Date"
                                        type="date"
                                        value={storedate}
                                        onChange={(e) => setstoredate(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                </div>

                                <div className="col-sm-12">
                                    <TextField
                                        fullWidth
                                        label="Bill Note 1"
                                        value={billnote1}
                                        onChange={(e) => setbillnote1(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                    <TextField
                                        fullWidth
                                        label="Bill Note 2"
                                        value={billnote2}
                                        onChange={(e) => setbillnote2(e.target.value)}
                                        size="small"
                                    /><br /><br />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
